module.exports = __webpack_public_path__ + "img/landingPage.7c210e0c.png";